export const alphaWhite = (opacity: number) => {
  return `rgba(255, 255, 255, ${opacity})`;
};

export default {
  alphaWhite,
};
